import type * as Ably from 'ably';

export const CONNECTION_LOST_MESSAGE = 'Connection lost. Please reattach to continue.';
export const UNABLE_TO_CONNECT_MESSAGE = 'Unable to connect. Please try again.';
export const TOKEN_FETCH_FAILED_MESSAGE = 'Unable to get authentication token. Please try again.';
export const NO_ANNOTATION_CAPABILITY_MESSAGE =
  'This API key does not have the annotation subscribe capability. Individual annotations will not appear.';
export const NO_OBJECT_SUBSCRIBE_CAPABILITY_MESSAGE =
  'This API key does not have the object-subscribe capability. LiveObjects operations will not appear. Select a key with the capability above.';
export const MUTABLE_MESSAGES_NOT_ENABLED_MESSAGE =
  'Mutable Messages is not enabled on this namespace, so annotation modes are unavailable. Enable it in the namespace settings to use them.';
export const NO_HISTORY_CAPABILITY_MESSAGE =
  'The selected API key does not have the history capability. Select an API key with the history capability to browse historical messages.';

const FRIENDLY_MESSAGES: Record<number, string> = {
  40160: 'The selected API key does not have the subscribe capability.',
  40171: 'The selected API key does not have the subscribe capability.',
};

const IGNORED_MESSAGES = ['Connection closed'];

// Error code returned on channel.attach() if mutable messages are not enabled on the namespace,
// but annotation_subscribe has been requested as a channel mode.
export const MUTABLE_MESSAGES_NOT_ENABLED_CODE = 93002;

// Capability-related attach failures (40160–40171) are permanent — the key simply
// lacks the required permissions, so retrying will never succeed.
export function isTerminalCapabilityError(code: number | undefined): boolean {
  return code !== undefined && code >= 40160 && code <= 40171;
}

function extractErrorCode(error: unknown): number | undefined {
  const ablyError = error as Ably.ErrorInfo | null;
  return ablyError?.code;
}

function extractErrorMessage(error: unknown): string | undefined {
  const ablyError = error as Ably.ErrorInfo | null;
  return ablyError?.message;
}

export function getAblyErrorMessage(error: unknown): string | null {
  const message = extractErrorMessage(error);
  if (message && IGNORED_MESSAGES.includes(message)) {
    return null;
  }

  const code = extractErrorCode(error);
  if (code && FRIENDLY_MESSAGES[code]) {
    return FRIENDLY_MESSAGES[code];
  }

  return message ?? UNABLE_TO_CONNECT_MESSAGE;
}
